import { defineRouting } from 'next-intl/routing';
import pathnames from '@/i18n/pathnames.json';
import { getDynamicRoutingConfig, localePrefixes, locales } from './domainConfig';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: locales,
  alternateLinks: false,
  // Used when no locale matches
  defaultLocale: 'de-DE',
  localePrefix: {
    mode: 'as-needed',
    prefixes: localePrefixes,
  },
  pathnames: pathnames,
  domains: getDynamicRoutingConfig(),
  localeDetection: false,
  localeCookie: false,
});
